import React from 'react'
import { withTranslation } from 'react-i18next'

const DataProcessingAgreement = ({ t }) => (
    <div className="policy-page">
        <h1>{t('_pages._data_processing_agreement.title')}</h1>
        <h3>{t('_pages._data_processing_agreement.last_updated')}</h3>
        <br />
        <br />
        <br />
        <p>{t('_pages._data_processing_agreement.text_1')}</p>
        <br />
        <p>
            {t('_pages._data_processing_agreement.more_info_contact')}{' '}
            <a href="mailto:info@interacty.me">info@interacty.me</a>
        </p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.definitions')}</h2>
        <p>{t('_pages._data_processing_agreement.text_2')}</p>
        <p>{t('_pages._data_processing_agreement.text_3')}</p>
        <p>{t('_pages._data_processing_agreement.text_4')}</p>
        <p>{t('_pages._data_processing_agreement.text_5')}</p>
        <p>{t('_pages._data_processing_agreement.text_6')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.relationship')}</h2>
        <p>
            {t('_pages._data_processing_agreement.text_7')}{' '}
            <a href="https://interacty.me/privacy-policy/.">https://interacty.me/privacy-policy/</a>.
        </p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.representations')}</h2>
        <p>{t('_pages._data_processing_agreement.text_8')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.processing_of_personal_data')}</h2>
        <p>{t('_pages._data_processing_agreement.text_9')}</p>
        <p>{t('_pages._data_processing_agreement.text_10')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.rights_of_data_subject')}</h2>
        <p>{t('_pages._data_processing_agreement.text_11')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.sub_processor')}</h2>
        <p>{t('_pages._data_processing_agreement.text_12')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.technical')}</h2>
        <p>{t('_pages._data_processing_agreement.text_13')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.security_incident')}</h2>
        <p>{t('_pages._data_processing_agreement.text_14')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.audit_rights')}</h2>
        <p>{t('_pages._data_processing_agreement.text_15')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.data_transfer')}</h2>
        <p>{t('_pages._data_processing_agreement.text_16')}</p>
        <br />
        <br />
        <h2>{t('_pages._data_processing_agreement.conflict')}</h2>
        <p>{t('_pages._data_processing_agreement.text_17')}</p>
        <br />
        <br />
    </div>
)

export default withTranslation('translations')(DataProcessingAgreement)
